import { useTranslation } from "react-i18next";

interface FormErrorProps {
  error?: string;
  className?: string;
  params?: Record<string, string | number>;
}

export default function FormError({
  error,
  className = "",
  params,
}: FormErrorProps) {
  const { t } = useTranslation();

  if (!error) return null;

  const translatedError = error.startsWith("error.") ? t(error, params) : error;

  console.log(params);
  return (
    <p className={`mt-1 text-sm text-red-600 ${className}`}>
      {translatedError}
    </p>
  );
}
